import React from 'react';
import { StatusConfig } from '../../types/admin';
import styles from './ApplicationStatusBadge.module.css';

type Variant = 'secondary' | 'info' | 'success' | 'danger';

const STATUS_VARIANT: Record<string, Variant> = {
  draft:                      'secondary',
  submitted:                  'info',
  under_admissibility_review: 'info',
  not_admissible:             'danger',
  admissible:                 'success',
  under_evaluation:           'info',
  evaluated:                  'info',
  selected:                   'success',
  not_selected:               'danger',
};

interface ApplicationStatusBadgeProps {
  status: string;
}

const ApplicationStatusBadge: React.FC<ApplicationStatusBadgeProps> = ({ status }) => {
  const variant = STATUS_VARIANT[status] ?? 'secondary';
  const label   = StatusConfig[status]?.label ?? status;

  return (
    <span className={`${styles.badge} ${styles[`badge--${variant}`]} uc-status`}>
      {label}
    </span>
  );
};

export default ApplicationStatusBadge;
